import OpenAPIClientAxios from 'openapi-client-axios';
import KioskSchema from '@checkit/openapi-specification/dist/kiosk-schema.json';
import apiconfig from 'src/apiconfig';
import { LocalStorage } from 'quasar';

let config;

if (process.env.DEV) {
  config = apiconfig.staging;
}
else {
  config = process.env.STAGING ? apiconfig.staging : apiconfig.production;
}

let { token } = config;

// Read from config to get the token
if (LocalStorage.has('CHECKIT_KIOSK_LOCATION')) {
  token = token[LocalStorage.getItem('CHECKIT_KIOSK_LOCATION')];
}
/*
else if (process.env.PROD && process.env.TERMINALID) {
  // Terminal 0 is for debugging.
  if (process.env.TERMINALID === '0') {
    // eslint-disable-next-line prefer-destructuring
    token = token[1];
  }
  else {
    token = token[process.env.TERMINALID];
  }
}
 */

const api = new OpenAPIClientAxios({
  definition: KioskSchema,
  withServer: config.url,
  validate: true,
  axiosConfigDefaults: {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json;charset=UTF-8',
    },
  },
});

api.init();

export default api;
